<template>
<div>
  <div v-if="loading" class="tw-bg-white tw-p-6 tw-rounded-xl tw-mb-8">
    <div class="tw-border-b tw-border-gray-200 tw-pb-2 tw-mb-4 tw-flex tw-justify-between">
      <shine-loading body_width="60" size="sm" />
      <shine-loading body_width="150" />
    </div>
    <div class="tw-flex tw-justify-between tw-mt-4">
      <shine-loading body_width="170" />
      <shine-loading body_width="25" />
    </div>
    <div class="tw-flex tw-justify-between tw-mt-4">
      <shine-loading body_width="200" />
      <shine-loading body_width="25" />
    </div>
    <div class="tw-flex tw-justify-between tw-mt-4">
      <shine-loading body_width="170" />
      <shine-loading body_width="25" />
    </div>
  </div>
  <div v-else-if="props.bankInformation" class="tw-bg-white tw-rounded-[10px] tw-py-6 tw-px-5 tw-mb-8">
    <div class="tw-flex tw-justify-between tw-pb-2 tw-border-b tw-border-gray-200">
      <div>
        <p class="tw-mb-0 tw-text-blue-dark-200">
          <span>{{ detectBank?.name || 'بانک نامشخص' }}</span>
          <base-icon icon="edit-note" size="20" class="tw-mr-4 tw-cursor-pointer" @click="showNewCreditBankModal" />
        </p>
        <span class="tw-mb-0  tw-text-blue-dark-500">بنام {{ props.bankInformation.owner_name }}</span>
      </div>
      <div>
        <img v-if="detectBank"
             :src="detectBank.logo"
             class="tw-flex-shrink-0"
             width="45px">
      </div>
    </div>
    <div class="tw-flex tw-justify-between tw-mt-4">
                  <span class="tw-text-blue-dark-300 ltr">
                    {{ props.bankInformation?.credit_card?.match(/.{1,4}/g).join(' ') || 'بدون شماره کارت' }}
                  </span>
      <base-icon icon="copy"
                 size="20"
                 :disabled="!!!props.bankInformation.credit_card"
                 :pointer="true"
                 @click="$copyToClipboard(props.bankInformation.credit_card, 'شماره کارت')"
                 class="tw-text-blue-dark-400" />
    </div>
    <div class="tw-flex tw-justify-between tw-mt-4">
                  <span v-if="props.bankInformation.shaba_num" class="tw-text-blue-dark-300 ltr">
                    {{ props.bankInformation.shaba_num }}
                  </span>
      <span v-else class="tw-text-blue-dark-300">بدون شماره شبا</span>
      <base-icon icon="copy"
                 size="20"
                 :disabled="!!!props.bankInformation.shaba_num"
                 :pointer="true"
                 @click="$copyToClipboard(props.bankInformation.shaba_num, 'شماره شبا')"
                 class="tw-text-blue-dark-400" />
    </div>
    <div class="tw-flex tw-justify-between tw-mt-4">
      <div class="tw-text-blue-dark-300 ltr">
        {{ props.bankInformation?.account_number || 'بدون شماره حساب' }}
      </div>
      <base-icon icon="copy"
                 size="20"
                 :disabled="!!!props.bankInformation.account_number"
                 :pointer="true"
                 @click="$copyToClipboard(props.bankInformation.account_number, 'شماره حساب')"
                 class="tw-text-blue-dark-400" />
    </div>
  </div>
  <div v-else class="tw-flex tw-justify-center tw-flex-col tw-gap-3 tw-bg-white tw-rounded-xl tw-items-center tw-text-tiny tw-text-blue-dark-200 tw-py-12 tw-px-6 tw-mb-8">
    اطلاعات بانکی ثبت نشده است

    <new-btn variant="outline"
              color="primary"
              @click="showNewCreditBankModal">
      افزودن اطلاعات بانکی
    </new-btn>
  </div>
</div>
  <add-new-credit-card v-model:visible="visible_modal_add_credit_card"
                       @updatedBank="emit('updatedBank')"
                       :bank_information="props.bankInformation"
                       :payment_able_id="payment_able_id"
                       @close="closeNewCreditBankModal" />
</template>

<script setup>

import BaseIcon from "@/components/base/BaseIcon.vue";
import ShineLoading from "@/components/loading/ShineLoading.vue";
import {computed, getCurrentInstance, ref} from "vue";
import AddNewCreditCard from "@/components/bank_informations/AddNewCreditCard.vue";
import NewBtn from "@/components/base/btn/NewBtn.vue";


const {proxy} = getCurrentInstance()
const visible_modal_add_credit_card = ref(null)

const emit = defineEmits(['updatedBank'])
const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  bankInformation: {
    type: Object,
    default: null
  },
  payment_able_id: {
    type: [String, Number, null],
    required: true,
  },
})


const detectBank = computed(() => {
  if(props.bankInformation && props.bankInformation?.credit_card) {
    return proxy.$detectBank(props.bankInformation.credit_card)
  }
  return null
})

const showNewCreditBankModal = () => {
  visible_modal_add_credit_card.value = true
}
const closeNewCreditBankModal = () => {
  visible_modal_add_credit_card.value = false
}
</script>

<style scoped>

</style>
